<app-header></app-header>

<header id="page_top" class="car_loan">
    <div class="webinar-image">
        <img [src]="eventInfo.bannerImage" alt="banner-image" class="img-responsive w-100">
    </div>
</header>

<div *ngIf="isRegVisible" class="floating-container">
    <h2 class="text-center" style="margin-top:0;">Register NOW!</h2>
    <form [formGroup]="eventRegister" (ngSubmit)="registerUserForEvent()">
        <div class="form-group"
            [class.has-error]="registerFormControl.userName.errors?.required || registerFormControl.userName.errors?.pattern">
            <input class="form-control" formControlName="userName" type="text" placeholder="Full Name">
            <span class="alert alert-danger small mt-1"
                *ngIf="(registerFormControl.userName.touched || submit) && registerFormControl.userName.errors?.required">
                Please enter your name!</span>
            <span class="alert alert-danger small mt-1"
                *ngIf="registerFormControl.userName.touched && registerFormControl.userName.errors?.pattern">
                Please enter your valid name!</span>
        </div>
        <div class="form-group"
            [class.has-error]="registerFormControl.email.errors?.required || registerFormControl.email.errors?.email">
            <input name="clientEmail" class="form-control" type="text"
                placeholder="E-mail" required formControlName="email">
            <span class="alert alert-danger small mt-1"
                *ngIf="(registerFormControl.email.touched || submit) && registerFormControl.email.errors?.required">
                Please enter your email address</span>
            <span class="alert alert-danger small mt-1"
                *ngIf="registerFormControl.email.touched && registerFormControl.email.errors?.email"> Please
                enter a valid email address</span>
        </div>
        <div class="form-group"
            [class.has-error]="registerFormControl.phone.errors?.required || registerFormControl.phone.errors?.pattern">
            <input class="form-control" formControlName="phone" (keypress)="validate0to9digit($event)" type="text" placeholder="Phone">
            <span class="alert alert-danger small mt-1"
                *ngIf="(registerFormControl.phone.touched || submit) && registerFormControl.phone.errors?.required">
                Please enter your contact number!</span>
            <span class="alert alert-danger small mt-1"
                *ngIf="(registerFormControl.phone.touched || submit) && !phoneValid">
                Invalid contact number!</span>
        </div>
        <button type="submit" class="btn btn-default quote_btn">REGISTER</button>
    </form>
</div>

<div class="outer-container">

    <section id="about-session" class="about">
        <div class="row">
            <div class="col-md-12">
                <h2 class="text-center">{{eventInfo.title}}</h2>
                
                <h3>About this Session:</h3>
                <quill-view-html [content]="eventInfo.aboutEvent" class="about-event" theme="snow"></quill-view-html>
                <h3>Key takeaways from this session:</h3>
                <ol>
                    <li *ngFor="let key of eventInfo.eventKeys">{{key}}</li>
                </ol>

                <h3>Instructor: {{eventInfo.instructor}} ({{eventInfo.instructorBio}})</h3>
            </div>
        </div>
    </section>

    <section id="about-omni" style="background:#f1f1f1;">
        <div class="row col-md-12">
            <div class="col-md-6">
                <h2 class="faq_title">About OMNI</h2>
                <p>OMNI is the world's First hands-on training platform for AI & RPA skills. Whether you are an
                    engineering fresher or a working professional, OMNI helps you master the most in-demand skills
                    of Artificial Intelligence (AI), Machine Learning (ML), Chatbots, Natural Language Processing
                    (NLP) and Robotic Process Automation (RPA). OMNI helps you level up your tech skills by giving
                    you access to many developer courses to make you job-ready through 1:1 mentorship and live
                    projects.</p>

                <p><strong>Dream Big with OMNI as it unlocks:</strong></p>
                <ul class="faq-list">
                    <li>Experiential Learning with hands-on training</li>
                    <li>Access to Top 25 AI & RPA tools</li>
                    <li>Industry Level Live Projects</li>
                    <li>1:1 mentoring by technology geeks and industry experts</li>
                    <li>Global Community of 35000 AI & Automation Experts</li>
                </ul>
            </div>

            <div class="col-md-6 mar-20t">
                <video [src]="eventInfo.video" class="h-27em" width="100%" controls>
                    <!-- <source [src]="eventInfo.video"
                        type="video/mp4"> -->
                </video>
            </div>
        </div>
    </section>

    <section id="reviews" class="blog">
        <div class="row">
            <div class="col-sm-12">
                <h2 class="setion-title text-center">What our Learners have to say</h2>
            </div>
        </div>

        <div class="row mr_top_10">

            <div class="col-md-6 mar-20t" *ngFor="let learner of eventInfo.learnerThought">
                <div class="blog_worp">
                    <div class="blog_content">
                        <h4>{{learner.title}}</h4>
                        <p>{{learner.description}}</p>
                    </div>
                </div>
            </div>

        </div>
    </section>
</div>

<hr>
<app-footer></app-footer>